import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { NoteService } from './note.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { FormControl, Validators } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
@Component({
    selector: 'ch-note',
    templateUrl: 'note.component.html',
    providers: [NoteService]
})

export class NoteComponent implements OnInit, OnChanges {
    @Output() saveConsultationEvent = new EventEmitter<any>();
    @Input() consultationId: string;
    public klass = 'consultationhistory';
    public note: string;
    public noteCtrl: FormControl;
    @Input() consultationNotes: any[];
    @Input() height: number;
    public error = Utility.stringFormat(AppMessages.errors.required, ['Note']);
    constructor(public noteService: NoteService, public dialogService: DialogService, public utility: Utility) {
        this.noteCtrl = new FormControl('', [Validators.required]);
    }

    ngOnInit() {
        this.height = this.height ? (this.height > 600 ? this.height - 172 : this.height - 185) : null;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes) {
            if (changes.consultationNotes) {
                if (changes.consultationNotes.firstChange === false) {
                    this.setNote();
                    this.noteCtrl.markAsUntouched();
                }
            }
        }
    }

    saveConsultationNote() {
        if (this.noteCtrl.valid) {
            this.saveConsultationEvent.emit(
                {
                    consultationId: this.consultationId,
                    // note: this.noteCtrl.value.replace(/<([^>]*)>/g, '($1)')
                    note: this.noteCtrl.value
                });
        }
    }

    setNote(str = '') {
        this.noteCtrl.setValue(str);
    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/note/note.component.ts